import { useState } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";
import { objectUtil } from "../../../../../utils";

import { Modal, SmallButton, SVG } from "../../../../../components";
import { AdminRoleForm } from "./AdminRoleForm";
import { AdminRoleSettingsContainer } from "./styled";
import { AdminRoleCard } from "./AdminRoleCard";

export const AdminRoleSettings = ({ rolesConfig, setRolesConfig }) => {
  const [selectedRoleConfig, setSelectedRoleConfig] = useState(null);

  const onEditRoleConfig = () => {
    setSelectedRoleConfig(rolesConfig ?? {});
  };

  const onClose = () => {
    setSelectedRoleConfig(null);
  };

  return (
    <AdminRoleSettingsContainer width={"100%"}>
      {!objectUtil.isEmpty(rolesConfig) ? (
        <AdminRoleCard roleConfig={rolesConfig} onEditConfig={onEditRoleConfig} />
      ) : (
        <SmallButton onClick={onEditRoleConfig}>
          <SVG.SettingsIcon /> {t(strCode.SET_UP_ROLE_BTN)}
        </SmallButton>
      )}

      <Modal
        id={"admin-role-form-modal"}
        active={selectedRoleConfig != null}
        setActive={onClose}
        closable={false}
        title={t(strCode.SET_UP_ROLE_BTN)}>
        <AdminRoleForm
          roleConfig={selectedRoleConfig}
          onClose={onClose}
          onSaveRole={setRolesConfig}
        />
      </Modal>
    </AdminRoleSettingsContainer>
  );
};

AdminRoleSettings.propTypes = {
  rolesConfig: PropTypes.arrayOf(
    PropTypes.shape({
      accessType: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      }).isRequired,
      roles: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired
        }).isRequired
      ).isRequired,
      applications: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired
        }).isRequired
      ).isRequired,
      markets: PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
        ).isRequired
      ).isRequired
    }).isRequired
  ),
  setRolesConfig: PropTypes.func.isRequired
};
